import { apiClient, PaginatedResponse, QueryParams } from '@/services/apiClient';
import { AddressAdminArea, AddressCountry, AddressLocality } from '@/types';

class AddressService {
  async getCountries(params: QueryParams = {}): Promise<PaginatedResponse<AddressCountry>> {
    return apiClient.getPaginated<AddressCountry>('/address-countries', params);
  }

  async getAdminAreas(params: QueryParams = {}): Promise<PaginatedResponse<AddressAdminArea>> {
    return apiClient.getPaginated<AddressAdminArea>('/address-admin-areas', params);
  }

  async getLocalities(params: QueryParams = {}): Promise<PaginatedResponse<AddressLocality>> {
    return apiClient.getPaginated<AddressLocality>('/address-localities', params);
  }
}

export const addressService = new AddressService();
